import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
// eslint-disable-next-line jira/import-whitelist -- error reporting is not on the resource allow list; matches every other router-resource
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import type { RfoBannerSettings } from './RfoBannerSettings.types.tsx';

/**
 * Read path for the RFO (Reason For Outage) announcement banner. Writes are owned by the RFO
 * micros service and are ASAP-authenticated, so there is deliberately no `set` here.
 *
 * Kept as a single exported constant so moving to a different read path (e.g. GraphQL) is a
 * one-line change.
 */
export const RFO_ANNOUNCEMENT_BANNER_ENDPOINT = '/rest/internal/1/rfo/announcement-banner';

/**
 * The banner is off whenever we cannot read the state. `401` means the request carried no session
 * cookie, which is every anonymous page view of a public site, `403` means the user may not read a
 * private banner, and `404` means the backend feature flag `rft-717-rfo-announcement-banner` is
 * off. None of the three is an error worth reporting.
 */
const disabled: RfoBannerSettings = {
	content: '',
	bgColor: 'yellow',
	isEnabled: false,
	isDismissable: false,
	visibility: 'private',
	hashId: '',
};

export const get = async (): Promise<RfoBannerSettings> => {
	try {
		return await performGetRequest(RFO_ANNOUNCEMENT_BANNER_ENDPOINT);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		if (error.statusCode === 401 || error.statusCode === 403 || error.statusCode === 404) {
			return disabled;
		}

		fireErrorAnalytics({
			meta: {
				id: 'rfoAnnouncementBannerGet',
				packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
				teamName: 'jira-cosmos',
			},
			error,
		});
		throw error;
	}
};

export const rfoAnnouncementBannerApiService: {
	get: () => Promise<RfoBannerSettings>;
} = {
	get,
};
